import React from "react"
import { useNavigate } from "react-router-dom"
import CustomFieldComponent from "./CustomField"
export const OtherDetails = ({ title, data }) => {
  const navigate = useNavigate()

  console.log(data)
  return (
    <div className="mb-2">
      <div className="d-flex align-items-center">
        <span className="text-primary fs-4 fw-medium">{title}</span>
        {data && data.length > 1 && (
          <i
            onClick={() =>
              navigate("/dynamic-edit", {
                state: {
                  data: [],
                  value: "",
                },
              })
            }
            className="bx bxs-edit ms-auto"
            style={{
              fontSize: "20px",
              borderRadius: "5px",
              color: "#0d6efd",
              cursor: "pointer",
            }}
          ></i>
        )}
      </div>
      {data && <CustomFieldComponent data={data} />}
    </div>
  )
}
